import React, { useEffect, useState } from 'react';
import { Pie, PieConfig } from '@ant-design/plots';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';

interface OkrCompletionStatusWidgetProps {
    rowSpan?: number;
    colSpan?: number;
}

interface StatusDatum {
    title: string;
    ratio: number;
}

const OkrCompletionStatusWidget: React.FC<OkrCompletionStatusWidgetProps> = ({
                                                                                 rowSpan = 1,
                                                                                 colSpan = 1,
                                                                             }) => {
    const themeColors = useSelector((state: RootState) => state.app?.themeColors);
    const [data, setData] = useState<StatusDatum[]>([]);

    useEffect(() => {
        setData([
            { title: 'Tamamlananlar', ratio: 25 },
            { title: 'Devam Edenler', ratio: 72 },
            { title: 'İptal Edilenler', ratio: 3 },
        ]);
    }, []);

    if (!data.length) return null;

    const config: PieConfig = {
        angleField: 'ratio',
        colorField: "title",
        // @ts-ignore
        data: data,
        scale: {
            color: { range: ['#32CD32', '#FFBF00', '#C0C0C0'] },
        },
        innerRadius: 0.6,
        label: {
            text: (d: any) => `${d.ratio}%`,
            position: "inside",
            style: {
                fontWeight: 'bold',
                fill: "#003262",
            },
        },
        legend: {
            color: {
                title: false,
                position: 'bottom',
                rowPadding: 5,

            },
        },
        style: {
            stroke: '#fff',
            inset: 1,
            radius: 10,
        },
        tooltip: {
            title: 'title',
            items: [{name: '', field: "ratio", valueFormatter: (d: any) => `${d} %`}],
        },
        interaction: {
            elementHighlight: true,
        },
        state: {
            inactive: {opacity: 0.5},
        },
    };

    const size = Math.min(colSpan * 120, rowSpan * 120);
    
    return (
        <div className="h-full w-full p-4 bg-white rounded shadow flex flex-col">
            <h2 className="text-lg font-semibold text-center mb-4">
                OKR Durumları (Hedef Tamamlamalara Göre)
            </h2>
            <div style={{ width: size, height: size, margin: '0 auto' }}>
                <Pie {...config} />
            </div>
        </div>
    );
};

export default OkrCompletionStatusWidget;
